import { useEffect, useState } from 'react';

import { useDispatch } from 'react-redux';

import DailyMessageModal from 'components/DailyMessageModal/DailyMessage';
import { headerButtonClickedIs, selectHeaderButton } from 'redux/header/header.slices';
import { useAppSelector } from 'redux/hooks';

import DailyMessageList from './components/DailyMessageList';
import './DailyMessage.scoped.scss';

const dummyUpcoming = [
  {
    message: 'Upcoming 1',
    eventDate: new Date(),
  },
  {
    message: 'Upcoming 2',
    eventDate: new Date(),
  },
  {
    message: 'Upcoming 3',
    eventDate: new Date(),
  },
];

const dummyOnGoing = [
  {
    message: 'On going 1',
    eventDate: new Date(),
  },
  {
    message: 'On going 2',
    eventDate: new Date(),
  },
  {
    message: 'On going 3',
    eventDate: new Date(),
  },
];

const dummyPrevious = [
  {
    message: 'Previous 1',
    eventDate: new Date(),
  },
  {
    message: 'Previous 2',
    eventDate: new Date(),
  },
  {
    message: 'Previous 3',
    eventDate: new Date(),
  },
];

const DailyMessage: React.FC = () => {
  const headerButtonIs = useAppSelector(selectHeaderButton);
  const [modal, toggleModal] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (headerButtonIs === 'DailyMessage') {
      toggleModal(true);
    }
  }, [headerButtonIs]);

  useEffect(() => {
    if (!modal) {
      dispatch(headerButtonClickedIs(''));
    }
  }, [modal]);

  const handleCloseModal = () => {
    toggleModal(!modal);
    dispatch(headerButtonClickedIs(''));
  };

  return (
    <div className="wrapper">
      <DailyMessageModal
        openModal={modal}
        handleModal={() => toggleModal(!modal)}
        handleCloseModal={() => handleCloseModal()}
      />
      <DailyMessageList upcoming={dummyUpcoming} ongoing={dummyOnGoing} previous={dummyPrevious} />
    </div>
  );
};

export default DailyMessage;
